export enum EncoderType {
    None,
    Salto,
    CafHotelSystem,
    JNF
}